import React, { useState } from 'react';
import CreateLocation from './CreateLocation';
import LocationMgtList from './LocationMgtList';
import { toast } from "../../../components/AppToast";
import { createLocation } from '../../../services/location/location';
import { updateLocationAPI } from '../../../services/location/location';
// import { saveLocationAPI, getLocationListAPI, updateLocationAPI } from '../../../services/location/location';

export default function LocationManagement() {
   
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null); // view/edit
    const [listVersion,setListVersion]=useState();
    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };


    const submitForm = async (formData, id) => {
        try {
            if (id) {
                // Update existing location
                try{
                      await updateLocationAPI(formData,id);
                    toast.success("Location updated successfully");
                    closeForm();
                }
                    
                 catch(err) {
                    toast.error("Location updation failed");
                }
            } else {
                // Create new location
                try{
                await createLocation(formData);
                    
                    toast.success("Location created successfully");
                    setListVersion(v=>v+1);
                    closeForm();
                }
                   
                catch(err) {
                    toast.error("Location creation failed");
                }
            }
        } catch (err) {
            throw err;
        }
    };

    return (
        <div className="card shadow-lg main-card">

            {/* ---------- HEADER ---------- */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Location Management"
                        : isCreating
                            ? "Create Location"
                            : activeRecord?.mode === "edit"
                                ? "Edit Location"
                                : "View Location"}
                </h4>
            </div>

            {/* ---------- BREADCRUMBS ---------- */}
            {onlyFormVisible && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Location Management
                            </button>
                        </li>

                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {isCreating
                                ? "Create Location"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Location"
                                    : "View Location"}
                        </li>
                    </ol>
                </nav>
            )}

            <div className="card-body">
                {!onlyFormVisible ? (
                    <LocationMgtList
                        refreshKey={listVersion}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) =>
                            setActiveRecord({ mode: "view", data: row })
                        }
                        onEdit={(row) =>
                            setActiveRecord({ mode: "edit", data: row })
                        }
                    />
                ) : (
                    <CreateLocation
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />
                )}
            </div>

        </div>
    );
}
